import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
declare var Flickity: any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  show: boolean;
  constructor(
    private router: Router,
    private platform: Platform,
    private el: ElementRef
  ) {
    this.isDesktop()

  }

  ngOnInit(): void {
  }
  isDesktop() {
    if (this.platform.is("desktop"))
      this.show = false
    else
      this.show = true
  }
  ngAfterViewInit(): void {
    if (this.show) {
      const el = this.el.nativeElement;
      const elem = el.querySelector('.flick');
      new Flickity(elem, {
        wrapAround: true,
        contain: true,
        autoPlay: 2500,
      });
    }

  }
  goto_sell() {
    this.router.navigate(["./software/sale"]);
  }

  goto_cafe() {
    this.router.navigate(["./software/cafe"])
  }

  goto_cloudcam() {
    this.router.navigate(["./software/cloudcam"])
  }

  goto_power_monitoring() {
    this.router.navigate(["./solution/power-monitoring"])
  }

  goto_smarthome() {
    this.router.navigateByUrl("solution/smarthome");
  }
  goto_security_cam() {
    this.router.navigateByUrl("solution/security-cam");
  }

  goto_agricultural() {
    this.router.navigateByUrl("solution/agricultural");
  }

  goto_material() {
    this.router.navigate(["./solution/material-production"])
  }

  goto_support_0() {
    this.router.navigate(["./support/sale"], { state: { id_active: 0 } })
  }
  goto_support_1() {
    this.router.navigate(["./support/sale"], { state: { id_active: 1 } })
  }

  goto_introduction() {
    this.router.navigate(["./introduction"])
  }

  goto_products() {
    this.router.navigate(["./products"])
  }

  goto_solution() {
    this.router.navigate(["./solution"])
  }

  goto_software() {
    this.router.navigate(["./software"])
  }

  goto_news() {
    this.router.navigate(["./news"])
  }

  goto_listPrice() {
    this.router.navigate(["./price"])
  }

  goto_contact() {
    this.router.navigate(["./contact"])
  }

  goto_recruitment() {
    this.router.navigate(["./recruitment"])
  }
  goto_promotion() {
    this.router.navigate(["./promotion"]);
  }

  goto_website() {
    this.router.navigate(["./outsource/website"])
  }

  goto_appmobile() {
    this.router.navigate(['./outsource/app-mobile'])
  }

  goto_iot() {
    this.router.navigate(['./outsource/iot'])
  }

  goto_system() {
    this.router.navigate(['./outsource/system'])
  }
  goto_download() {
    this.router.navigate(["./download"])
  }
  goto_outsource() {
    this.router.navigate(["./outsource"])
  }
  goto_policy() {
    this.router.navigate(["./privacy-policy"]);
  }
  goto_reg() {
    this.router.navigate(["./quy-dinh-su-dung-phan-mem"]);
  }

}
